import script from "./live.vue?vue&type=script&setup=true&name=Live&lang=js"
export * from "./live.vue?vue&type=script&setup=true&name=Live&lang=js"

import "./live.vue?vue&type=style&index=0&id=d4aa36aa&scoped=true&lang=css"

import exportComponent from "D:\\Jawsro\\company\\虎鲸\\v3\\hujing_pro_h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d4aa36aa"]])

export default __exports__